import { motion } from "framer-motion";
import { trackEvent } from "@/lib/tracking";

export default function Reveal({ children, delay = 0, className = "", trackLabel, y = 24 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
      onViewportEnter={() => {
        if (trackLabel) trackEvent("section_view", { label: trackLabel });
      }}
    >
      {children}
    </motion.div>
  );
}
